<template>
  <div class="contentView__works" ref="contents">
    <div class="applab__work" v-for="item in data" :key="item.pk">
      <WorkItem :dic="item" :item-height="work_img_height" @joinActivity='joinActivity' :data-type="dataType" :number='number' />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import { Utils } from '../utils'
import { POST } from '../utils/request'

import WorkItem from './scratch/components/WorkItem.vue'

import { types as WorkTypes } from '../store/modules/work'
import { types as CompanyTypes } from '../store/modules/company'

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'WorkList',
  components: {
    WorkItem
  },
  props: {
    dataType: {
      type: String,
      default: ''
    },
    number: {
      type: String,
      default: ''
    },
    work_type: String,
    typeArr: Array
  },
  data () {
    return {
      work_img_height: 100,
      scratch3: [],
      applab: [],


    }
  },
  watch: {
    work_type () {
      if (this.dataType === 'activity_works') {
        this.fetchActivityWorks({
          page: 1,
          number: this.number,
          data_type: this.dataType,
          work_type: this.work_type
        })
      }
    }
  },
  computed: {
    ...mapState({
      page: state => state.work.page,
      load_more: state => state.work.load_more,
      activity_page: state => state.work.activity_works.page,
      activity_load_more: state => state.work.activity_works.load_more,
      data (state) {
        if (this.dataType === 'activity_works') {
          return state.work.activity_works.data
        } else {
          return state.work.data
        }
      }
    }),
  },

  methods: {
    ...mapActions({
      fetchMyWorks: WorkTypes.FETCH_LIST_MY_WORKS,
      fetchLikeWorkEvent: WorkTypes.FETCH_LIKE_EVENT,
      fetchCreateProduct: CompanyTypes.FETCH_PRODUCT_CREATE,
      fetchDeleteWorkEvent: WorkTypes.FETCH_DELETE_WORK,
      fetchActivityWorks: WorkTypes.FETCH_LIST_ACTIVITY_WORKS,
      // fetchActivityWorks: WorkTypes.FETCH_LIST_ACTIVITY_WORKS,
    }),
    ...Utils,
    handleScroll (e) {
      var that = this
      let height = document.body.clientHeight
      let scrollHeight = document.body.scrollHeight
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop

      // if(e && e.target){
      //   height = e.target.offsetHeight
      //   scrollHeight = e.target.scrollHeight
      //   scrollTop = e.target.scrollTop
      // }

      // console.log("作品列表:", height, scrollHeight, scrollTop);
      // console.log(height, scrollHeight, scrollTop);
      let load_more = that.load_more
      let page = that.page
      if (that.dataType === 'activity_works') {
        load_more = that.activity_load_more
        page = that.activity_page
      }
      if (scrollHeight <= height + scrollTop + 20) {
        if (load_more) {
          console.log('还有更多数据，到达底部，继续加载新数据(作品)')
          if (that.dataType === 'activity_works') {
            that.fetchActivityWorks({
              page: page + 1,
              number: that.number,
              data_type: that.dataType,
              work_type: this.work_type
            })
          } else {
            that.fetchMyWorks({
              page: page + 1,
              user_id: that.user_id,
              data_type: that.dataType
            })
          }
        } else {
          console.log('没有新数据了')
        }
      } else {
        console.log('没到底部')
      }
    },
    //点赞作品
    likeWorkEvent (item) {
      this.fetchLikeWorkEvent({ pk: item.pk, data_type: this.dataType })
    },
    //作品详情页
    jumpToWorkDetail (item) {
      let host = location.host
      if (location.host.indexOf('develop.cxy61.com') > -1) {
        host = 'app.bcjiaoyu.com'
      }
      window.open(
        `https://${host}/html/works/works_detail.html?pk=${item.pk}`,
        '_blank'
      )
    },
    // 将作品放到公司产品中
    sendToCompanyEvent (item) {
      this.fetchCreateProduct({ showwork_id: item.pk })
    },
    // 删除作品
    deleteWork (item) {
      this.fetchDeleteWorkEvent({ pk: item.pk, data_type: this.dataType })
    },
    //参加活动
    joinActivity (item) {
      if (!this.typeArr.includes(item.work_type)) {
        this.$message.error('该作品类型与活动要求类型不同');
        return
      }
      POST(`/server/show/activity/${this.number}/showworks_create_by_id/`,
        {
          pk: item.pk
        })
        .then(res => {
          this.$message.success('成功参与')
        })
    }


  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted () {
    console.log('初始请求[作品]')
    this.work_img_height = parseInt(
      this.$refs.contents.clientWidth / 4 - 12 - 2
    )

    let user_id = this.$route.params.user
    this.user_id = user_id
    if (this.dataType === 'activity_works') {
      this.fetchActivityWorks({
        page: 1,
        number: this.number,
        data_type: this.dataType,
        work_type: this.work_type
      })
    } else {
      this.fetchMyWorks({ page: 1, user_id: user_id, data_type: this.dataType })
    }
  }
}
</script>

<style lang="less" scoped>
.contentView__works {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: calc(100% - 10px);
  margin: auto;
  padding-top: 10px;
  padding-left: 10px;
  // margin-top: 33px;
}
.applab__work {
  width: calc(100% / 4 - 12px);
  /* width: 143px; */
  background-color: #ffffff;
  border: solid 1px #ebebeb;
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  .aa {
    width: 100px;
    height: 100px;
    background-color: red;
  }
}
.applab__work__img {
  width: 100%;
  height: 140px;
  background-color: #e1e1e1;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999;
  .box {
    padding: 6px;
    background: #6b45e1;
    border-radius: 6px;
    width: fit-content;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .close {
      position: absolute;
      right: -45px;
      top: -15px;
      img {
        width: 30px;
        display: block;
        cursor: pointer;
      }
    }
    .content {
      padding: 25px 100px;
      background: #fff;
      border-radius: 6px;
      .btn {
        text-align: center;
        margin-top: 20px;
        button {
          background: rgba(255, 123, 0, 1);
          border-radius: 3px;
          color: #ffffff;
          font-size: 14px;
          height: 24px;
          padding: 0 15px;
          cursor: pointer;
        }
      }
      .radio {
        /deep/.el-radio {
          margin-right: 50px;
        }
        /deep/.el-radio:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
